import { service } from "@ember/service";
import Route from "@ember/routing/route";
import { action } from "@ember/object";
import RSVP from "rsvp";
import { findAll } from "@warp-drive/legacy/compat/builders";
import { updateUrlFor } from "glesys-controlpanel/utils/url";

export default class DashboardRoute extends Route {
  @service session;
  @service current;
  @service store;
  @service theme;
  @service router;
  @service errorHandler;

  activate() {
    this.theme.setup();
  }

  beforeModel(transition) {
    return this.session.requireAuthentication(transition);
  }

  model() {
    let organizations = this.store.peekAll("organization");
    let dataCenter = this.store.request(findAll("data-center")).then((response) => response.content);

    return RSVP.hash({
      dataCenter,
      organizations,
      user: this.session.currentUser,
      projects: RSVP.all(
        organizations.map((organization) => {
          return organization.get("projects").then((projects) => {
            return RSVP.all(
              projects.map((project) => {
                return project;
              }),
            );
          });
        }),
      ).then((map) => [].concat(...map)),
    });
  }

  @action
  error(error, transition) {
    this.errorHandler.handleError(error);
    updateUrlFor(transition, this.router);
    this.intermediateTransitionTo("dashboard.error", error);
    return false;
  }

  @action
  loading(transition) {
    // eslint-disable-next-line ember/no-controller-access-in-routes
    let controller = this.controllerFor("dashboard");
    controller.set("isLoading", true);
    transition.promise.finally(() => controller.set("isLoading", false));
  }
}
